import dayjs from 'dayjs';
import {useIntl} from 'react-intl';

export const useHumanizedTime = (millis: number): string => {
  const intl = useIntl();

  const parts = [];
  const dayjsDuration = dayjs.duration(millis);

  if (!dayjsDuration || dayjsDuration.toISOString() === 'P0D') return '';

  if (dayjsDuration.days() >= 1) {
    return intl.formatMessage({id: 'common.dayCount'}, {count: dayjsDuration.days()});
  }

  if (dayjsDuration.hours() >= 1) {
    const hours = Math.floor(dayjsDuration.hours());
    parts.push(intl.formatMessage({id: 'common.hourCount'}, {count: hours}));
  }

  if (dayjsDuration.minutes() >= 1) {
    const minutes = Math.floor(dayjsDuration.minutes());
    parts.push(intl.formatMessage({id: 'common.minuteCount'}, {count: minutes}));
  }

  if (dayjsDuration.seconds() >= 1) {
    const seconds = Math.floor(dayjsDuration.seconds());
    parts.push(intl.formatMessage({id: 'common.secondCount'}, {count: seconds}));
  }

  return parts.join(' ');
};
